export const ZOOMED_ATTRIBUTE = 'zoomed';
